var pt = pt || {};
pt.blocografico = pt.blocografico || {};
pt.blocografico.modules = pt.blocografico.modules || {};
pt.blocografico.modules.mission_and_values = pt.blocografico.modules.mission_and_values || {};
pt.blocografico.modules.mission_and_values = (function () {
  function init() {}

  return { init };
})();

document.addEventListener("DOMContentLoaded", function () {
  pt.blocografico.modules.mission_and_values.init();
});
